import { combineLatest, map } from "rxjs";
import {
    setESPEquipmentForSensor,
    setESPEquipmentsForMotor,
    setMotorInputHP,
    setMotorInputHP60,
    setMotorLoadInput,
    setSelectedMotor
} from "../../../../src/store/calculation/calculation-output/motorSlice";
import {
    setHiddenMotorId
} from "../../../../src/store/calculation/calculation-input/TubingSlice";
import { useAppDispatch } from "../../../store/hooks/StoreHooks";
import tubingFacade from "../calculation-input/tubing.facade";
import { MotorDto } from "../../../store/model/calculations/motor";
import { setESPEquipmentsForBOH } from "../../../store/calculation/calculation-output/pumpSlice";
import {
    setDepthOfMaxDLS,
    setMaxDLSAboveKOP,
    setWellKOPOverride,
    setTransitionZone,
    setTailPipeLength,
    setTailPipeBottom,
    setTailPipeInsideTZ,
    setWellDataInMainReportFlag,
    setNotes,
    clearWellSurveyData
} from "../../../store/calculation/calculation-output/wellSurveySlice";



const useWellSurveyFacade = () => {
    const dispatch = useAppDispatch();


    const updateKOPOverride = async (payload: any) => {
        return await dispatch(setWellKOPOverride(payload));
    };
    const updateMaxDLSAboveKOP = async (payload: any) => {
        return await dispatch(setMaxDLSAboveKOP(payload));
    };
    const updateDepthOfMaxDLS = async (payload: any) => {
        return await dispatch(setDepthOfMaxDLS(payload));
    }
    const updateTransitionZone = async (payload: number) => {
        return await dispatch(setTransitionZone(payload));
    };

    const updateTailPipeLength = async (payload: number) => {
        return await dispatch(setTailPipeLength(payload));
    };

    const updateTailPipeBottom = async (payload: number) => {
        return await dispatch(setTailPipeBottom(payload));
    };

    const updateTailPipeInsideTZ = async (payload: number) => {
        return await dispatch(setTailPipeInsideTZ(payload));
    };
    const updateWellDataInMainReportFlag = async (payload: boolean) => {
        return await dispatch(setWellDataInMainReportFlag(payload));
    };

    const updateWellNotes = (payload: any) => {
        return dispatch(setNotes(payload));
    };

    const clearWellSurvey = () => {
        return dispatch({ type: "wellSurvey/clearData" });
    };

    return {
        updateKOPOverride,
        updateMaxDLSAboveKOP,
        updateDepthOfMaxDLS,
        updateTransitionZone,
        updateTailPipeLength,
        updateTailPipeBottom,
        updateTailPipeInsideTZ,
        updateWellDataInMainReportFlag,
        updateWellNotes,
        clearWellSurvey
    };
};

export default useWellSurveyFacade;
